import { render, staticRenderFns } from "./IntegralRanking.vue?vue&type=template&id=38b7dcf5&scoped=true&"
import script from "./IntegralRanking.vue?vue&type=script&lang=js&"
export * from "./IntegralRanking.vue?vue&type=script&lang=js&"
import style0 from "./IntegralRanking.vue?vue&type=style&index=0&id=38b7dcf5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b7dcf5",
  null
  
)

export default component.exports